import { useLocation } from 'react-router-dom';
import { ProductSummaryType } from '../../types/types';
import { useContentSquare } from '../useContentSquare';
import { useAdobeAnalytics } from '../useAdobeAnalytics';
import { getProductSummary } from '../../store/selectors/getProductSummary';
import { useNativePageChange } from '@vm/omega-shared-component-webapp';

/**
 * A hook used to call other hooks that are concerned when the route/page changes
 */
export const useRouteChange = () => {
  const location = useLocation();
  const productSummaryData: ProductSummaryType = getProductSummary();

  useContentSquare(location, productSummaryData);
  useAdobeAnalytics(location, productSummaryData);
  useNativePageChange(location);
};
